import { useTranslation } from 'react-i18next';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const FunctionalityStageAccordion = ({ stageProperties, setStageProperties, currentStage }) => {
    const { t } = useTranslation();
    // Removes any digits  that appear after a space in the string.
    const procesName = (cadena) => cadena.replace(/ \d+/g, '');
    // Reorders a list by moving an item from the startIndex to the endIndex.
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };
    // Handles the end of a drag-and-drop operation, reordering the shapes based on the drag result.
    const onDragEnd = (result) => {
        if (!result.destination) return;

        const shapesList = stageProperties[currentStage].combinedObject.reverse();
        const reorderedObjects = reorder(shapesList, result.source.index, result.destination.index);
        const originalShapeList = reorderedObjects.reverse();

        setStageProperties((prevProperties) => ({
            ...prevProperties,
            [currentStage]: {
                ...prevProperties[currentStage],
                combinedObject: originalShapeList,
            },
        }));
    };
    // Deletes a shape by its id from a specific property in the current stage.
    const handleDeleteShape = (id, property) => {
        if (!id) return;

        setStageProperties((prevProperties) => {
            const currentProperties = prevProperties[currentStage];
            const updatedSpecificProperty = currentProperties[property].filter((fig) => fig?.id !== id);
            const updatedCombinedObject = currentProperties.combinedObject.filter((fig) => fig?.id !== id);

            return {
                ...prevProperties,
                [currentStage]: {
                    ...currentProperties,
                    [property]: updatedSpecificProperty,
                    combinedObject: updatedCombinedObject,
                },
            };
        });
    };

    return {
        t,
        procesName,
        onDragEnd,
        handleDeleteShape,
    };
};

export default FunctionalityStageAccordion;
